import { PaymentMethod } from '@frontend/api-payment-plans';
import { classNames } from '@frontend/string';
import { Prettify } from '@frontend/types';
import { PaymentMethodCard, PaymentMethodCardProps } from '../payment-method/payment-method-card';
import { PaymentMethodsListContainer } from './payment-methods-list-container';

export type PaymentMethodListCardProps = Prettify<
  Omit<PaymentMethodCardProps, 'isSelected' | 'paymentMethod'> & {
    isLoading: boolean;
    selectedPaymentMethod: PaymentMethod | null;
    paymentMethods: PaymentMethod[];
    className?: string;
  }
>;
export const PaymentMethodListCard = ({
  isLoading,
  paymentMethods,
  selectedPaymentMethod,
  onSelectPaymentMethod,
  onClickDelete,
  className,
}: PaymentMethodListCardProps) => {
  return (
    <PaymentMethodsListContainer isLoading={isLoading} className={classNames('payment-methods__list-card', className)}>
      {paymentMethods.map((pm) => (
        <PaymentMethodCard
          key={pm.id}
          isSelected={selectedPaymentMethod?.id === pm.id}
          paymentMethod={pm}
          onSelectPaymentMethod={onSelectPaymentMethod}
          onClickDelete={onClickDelete}
        />
      ))}
    </PaymentMethodsListContainer>
  );
};
